import { Component } from '@angular/core';
import { HeaderComponent } from "../../../../layout/header/header.component";
import { NavbarComponent } from "../../../../layout/navbar/navbar.component";
import { SidebarComponent } from "../../../../layout/sidebar/sidebar.component";
import { LangChangeEvent, TranslateDirective, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RoutelinksService } from '../../../../services/core/routelinks.service';
import { PaginatorComponent } from "../../../../components/paginator/paginator.component";
import { DiscountControlTypesRequest, DiscountControlTypesResponse } from '../../../../models/discountGeneralCatalog/DiscountControlTypesDto.model';
import { DiscountService } from '../../../../services/discountService.service';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-types-control',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent, TranslatePipe, TranslateDirective, PaginatorComponent,CommonModule],
  templateUrl: './types-control.component.html',
  styleUrl: './types-control.component.css'
})
export class TypesControlComponent {
  links: any[] = [];
  typeResponse: DiscountControlTypesResponse = new DiscountControlTypesResponse();
  typeRequest: DiscountControlTypesRequest = new DiscountControlTypesRequest();
    private langChangeSubscription!: Subscription;
  
  constructor(private translateService: TranslateService,private routelinks: RoutelinksService, private discountService: DiscountService) { }

  ngOnInit(): void {
    this.links = this.routelinks.linksDiscount;
    this.loadDiscountControlTypes()
      this.langChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
        this.loadDiscountControlTypes()
      });
    }
  
    ngOnDestroy(): void {
      if (this.langChangeSubscription) {
        this.langChangeSubscription.unsubscribe(); // Desuscribirse del evento de cambio de idioma
      }
    }

  loadDiscountControlTypes(){
    this.discountService.getListDiscountControlType(this.typeRequest.pageRequest).subscribe({
      next: response => {
        if (response != null) {
          this.typeResponse.DiscountControlTypesDto = response.listDiscountControlType;
          response.pageDto !== undefined ? this.typeResponse.pageDto = response.pageDto : null
        }
      }, error: error => {
        console.log('Se ha producido un error', error);
      }
    });
  }


}
